module.exports = __webpack_public_path__ + "static/media/jetdatauploadfile.eb9db669.xlsx";